<template>
  <b-card>

    <!-- media -->
    <!-- <b-media no-body>
      <b-media-aside>
        <b-link>
          <b-img
            ref="previewEl"
            rounded
            :src="userData.foto"
            height="80"
            :key="reloadImg"
          />
        </b-link>
      </b-media-aside>

      <b-media-body class="mt-75 ml-75">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="$refs.refInputEl.$el.click()"
        >
          Upload
        </b-button>
        <b-form-file
          ref="refInputEl"
          v-model="profileFile"
          accept=".jpg, .png, .gif"
          :hidden="true"
          plain
          @change="onFileSelected"
        />

        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75"
        >
          Reset
        </b-button>
        <b-card-text>Allowed JPG, GIF or PNG. Max size of 800kB</b-card-text>
      </b-media-body>
    </b-media> -->
    <!--/ media -->

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Nama"
            label-for="account-name"
          >
            <b-form-input
              v-model="biodata.nama"
              name="Nama"
              placeholder="Nama"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="E-mail"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="biodata.email"
              name="email"
              placeholder="Email"
              readonly
            />

          </b-form-group>
        </b-col>

        <!-- alert -->
        <!-- <b-col
          cols="12"
          class="mt-75"
          v-if="$route.params.warning_show === true"
        >
          <b-alert
            show
            variant="warning"
            class="mb-50"
          >
            <h4 class="alert-heading">
              Lengkapi NPM Anda pada tab Biodata
            </h4>
            <div class="alert-body">
              <b-link class="alert-link">
                Terimakasih
              </b-link>
            </div>
          </b-alert>
        </b-col> -->
        <!--/ alert -->

        <b-col cols="12" class="mt-2">
          <b-form-group
            label="Tanda Tangan (TTD)"
            label-for="account-ttd"
          >
            <div class="d-flex align-items-center">
              <b-img
                v-if="ttdPreview || biodata.ttd"
                :src="ttdPreview || biodata.ttd"
                height="100"
                class="mr-2 border rounded"
                style="background-color: #f8f8f8;"
              />
              <div v-else class="mr-2 border rounded d-flex align-items-center justify-content-center" style="height: 100px; width: 150px; background-color: #f8f8f8;">
                <span class="text-muted small">Belum ada TTD</span>
              </div>
              <div class="ml-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  size="sm"
                  class="mb-75"
                  @click="$refs.refInputTtd.$el.click()"
                >
                  Unggah TTD
                </b-button>
                <b-form-file
                  ref="refInputTtd"
                  v-model="ttdFile"
                  accept=".png, .jpg, .jpeg"
                  :hidden="true"
                  plain
                  @change="onTtdSelected"
                />
                <b-card-text class="small text-warning">
                   Wajib memiliki background transparan (format PNG disarankan).
                </b-card-text>
              </div>
            </div>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="simpanData"
          >
            Simpan
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BFormFile, BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BMedia, BMediaAside, BMediaBody, BLink, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  getUser,
  ubahNama,
  uploadTtd,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BImg,
    BFormFile,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      profileFile: null,
      ttdFile: null,
      ttdPreview: null,
      reloadImg: 0,
      biodata: {},
    }
  },
  mounted() {
    getUser()
      .then(response => {
        if (response.data.success == true) {
          this.biodata = response.data.data
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    renderImage() {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.userData.foto = reader.result;
        this.reloadImg += 1
      });
      reader.readAsDataURL(this.profileFile);
    },
    onFileSelected(event) {
      this.profileFile = event.target.files[0];
      this.renderImage();
    },
    onTtdSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.ttdFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.ttdPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async simpanData() {
      // If there's a new TTD file, upload it first
      if (this.ttdFile) {
        try {
          const response = await uploadTtd(this.ttdFile);
          if (response.data.success) {
            this.biodata.ttd = response.data.data.ttd;
            this.ttdPreview = null;
            this.ttdFile = null;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Update TTD',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Tanda tangan berhasil diunggah',
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Update TTD',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
                text: response.data.message,
              },
            });
            return; // Abort saving profile if TTD upload fails
          }
        } catch (error) {
          console.error(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'Gagal mengunggah tanda tangan',
            },
          });
          return;
        }
      }

      ubahNama(this.biodata)
      .then(response => {
        if (response.data.success == true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data Berhasil Disimpan',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
    }
  },
}
</script>
